module.exports = __webpack_public_path__ + "static/media/submitter-log.f7c4c30b.svg";